/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'arrow-circle-right': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M11.75 23.938c0 6.731 5.457 12.188 12.187 12.188 6.731 0 12.188-5.456 12.188-12.188S30.668 11.75 23.937 11.75c-6.73 0-12.187 5.456-12.187 12.188zM18 22.5c0-.275.225-.5.5-.5H24v-3.532c0-.275.173-.357.384-.18l6.398 5.329a.404.404 0 0 1 0 .641l-6.398 5.329c-.211.177-.384.096-.384-.18V26h-5.5a.501.501 0 0 1-.5-.5v-3z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/arrow-circle-right.js